import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ShareVnDataService {

  setVersicherungsnehmerForAntragOffert(currentFormData: any, targetForm: UntypedFormGroup) {
    if (currentFormData && targetForm) {
      targetForm.patchValue(currentFormData, { onlySelf: false, emitEvent: false });
    }
  }
}
